import { u as l } from "../useRecycleScroller-D_RDrEg2.js";
function n(e, r, o, u, c) {
  return l(
    e,
    r,
    o,
    u,
    c,
    {
      pageMode: !0
    }
  );
}
export {
  n as useWindowScroller
};
//# sourceMappingURL=useWindowScroller.js.map
